import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const paymentDetails = localStorage.getItem("paymentDetails"); // or use context/state if available

  if (!paymentDetails) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
